import { useContext } from 'react';

import { UrqlClientContext } from '../contexts';

export const useUrqlClient = () => useContext(UrqlClientContext);
